export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_04_05.59473cc7.mp4";